import { LocalizedText, useDialogAction } from '@mews/framework';
import { Button, IconButton } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { AssignPropertiesDialog } from './AssignPropertiesDialog';

interface AssignPropertiesContainerProps {
    rateGroupId: string;
    buttonTextKey?: Mews.TextKey;
}

export const AssignPropertiesContainer = ({ rateGroupId, buttonTextKey }: AssignPropertiesContainerProps) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());

    return (
        <>
            {buttonTextKey != null ? (
                <Button variant="tertiary" icon={IconName.Add} onClick={handlers.handleOpen} type="submit">
                    <LocalizedText textKey={buttonTextKey} />
                </Button>
            ) : (
                <IconButton icon={IconName.Add} onClick={handlers.handleOpen} type="submit" />
            )}
            {states.isDialogOpened && (
                <AssignPropertiesDialog
                    isOpened={states.isDialogOpened}
                    onClose={handlers.handleCancel}
                    onSuccess={handlers.handleConfirm}
                    rateGroupId={rateGroupId}
                />
            )}
        </>
    );
};
